import type { Service } from '@bharat-consultancy/shared';
import { ServiceCard } from './ServiceCard';

export function RelatedServices({ services }: { services: Service[] }) {
  if (services.length === 0) return null;

  return (
    <section>
      <h2 className="font-display text-2xl font-bold text-ink">Related Services</h2>
      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((service) => (
          <ServiceCard key={service.id} service={service} />
        ))}
      </div>
    </section>
  );
}
